export default (links?: any[]) => {
    if (links && links.length > 0) {
        const modalLink = links?.find(x => x.content._contentType === "modalLink");
        const anchorLink = links?.find(x => x.content._contentType === "anchorLink");
        const link = links?.find(x => x.content._contentType === "internalLink" || x.content._contentType === "externalLink");

        if (modalLink) {
            return modalLink;
        }
        else if (anchorLink) {
            return anchorLink;
        }
        else {
            return link;
        }
    }
};